import React from 'react';
import { Building, Briefcase, Clock } from 'lucide-react';

/**
 * Секция профиля компании для формы оценки риска банкротства
 */
const CompanyProfileSection = ({ 
  formData, 
  handleInputChange, 
  errors,
  companyTypes,
  industryTypes
}) => {
  return (
    <div className="mb-6 bg-gray-50 dark:bg-gray-800/30 p-4 rounded-lg border border-gray-200 dark:border-gray-700">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Building className="w-5 h-5 mr-2 text-orange-500" />
        Профиль компании
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Тип предприятия */}
        <div>
          <label htmlFor="companyType" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Building className="w-4 h-4 mr-1 text-gray-500 dark:text-gray-400" />
            Организационно-правовая форма
          </label>
          <select
            id="companyType"
            name="companyType"
            value={formData.companyType}
            onChange={handleInputChange}
            className={`form-select w-full ${errors.companyType ? 'input-error' : ''}`}
          >
            <option value="">Выберите тип предприятия</option>
            {companyTypes.map((type) => (
              <option key={type.id} value={type.id}>
                {type.name}
              </option>
            ))}
          </select>
          {errors.companyType && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.companyType}
            </p>
          )}
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
            Юридическая форма влияет на структуру капитала и нормативные требования.
          </p>
        </div>

        {/* Отрасль деятельности */}
        <div>
          <label htmlFor="industryType" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Briefcase className="w-4 h-4 mr-1 text-gray-500 dark:text-gray-400" />
            Отрасль деятельности
          </label>
          <select
            id="industryType"
            name="industryType"
            value={formData.industryType}
            onChange={handleInputChange}
            className={`form-select w-full ${errors.industryType ? 'input-error' : ''}`}
          >
            <option value="">Выберите отрасль</option>
            {industryTypes.map((type) => (
              <option key={type.id} value={type.id}>
                {type.name}
              </option>
            ))}
          </select>
          {errors.industryType && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.industryType}
            </p>
          )}
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
            Разные отрасли имеют разные нормы финансовых показателей и факторы риска.
          </p>
        </div>

        {/* Возраст компании */}
        <div>
          <label htmlFor="companyAge" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Clock className="w-4 h-4 mr-1 text-gray-500 dark:text-gray-400" />
            Возраст компании (лет)
          </label>
          <input
            type="text"
            id="companyAge"
            name="companyAge"
            value={formData.companyAge}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.companyAge ? 'input-error' : ''}`}
            placeholder="Количество лет"
          />
          {errors.companyAge && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.companyAge}
            </p>
          )}
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
            Количество лет с момента регистрации предприятия.
          </p>
        </div>
      </div>

      {/* Важность данных */}
      <div className="mt-4 p-3 bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-100 dark:border-yellow-800 rounded-md text-sm text-yellow-700 dark:text-yellow-300">
        <div className="flex items-start">
          <Briefcase className="w-5 h-5 text-yellow-500 dark:text-yellow-400 mr-2 flex-shrink-0 mt-0.5" />
          <div>
            <p className="text-xs text-yellow-600 dark:text-yellow-400">
              <span className="font-medium">Важно:</span> Профиль компании влияет на интерпретацию финансовых показателей. Для молодых компаний и некоторых отраслей (например, ИТ или стартапы) могут применяться скорректированные нормативы оценки.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanyProfileSection;